import {getStylesheetEl} from '@/utils/useStylesheet'
import ResolutionMixin from '@/components/mixins/ResolutionMixin'

export default {
  mixins: [ResolutionMixin],
  watch: {
    resolutioner () {
      this.updateViewport()
    }
  },
  methods: {
    updateViewport () {
      const styleEl = getStylesheetEl()
      const sheet = styleEl?.sheet
      if (!sheet) return

      const keys = {
        lg: 0,
        md: 1,
        sm: 2
      }

      const resIndex = keys[this.resolutioner]
      if (resIndex == null) return

      const media = ['screen', '(max-width: 1100px)', '(max-width: 520px)']
      const mediaRules = Array.from(sheet.cssRules || [])
        .filter(rule => rule?.type === CSSRule.MEDIA_RULE)
        .slice(0, media.length)

      mediaRules.forEach((_media, index) => {
        if (!_media?.media) return

        if (resIndex >= index) {
          _media.media.mediaText = 'screen'
        } else {
          _media.media.mediaText = media[index]
        }
      })
    }
  }
}
